import React from 'react';
import PublicLayout from '../../components/layouts/PublicLayout';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import FormInput from '../../components/forms/FormInput';
import FormTextarea from '../../components/forms/FormTextarea';
import { useToast } from '../../components/common/Toast';
import { useForm } from '../../hooks/useForm';
import { validators } from '../../utils/validators';
import { theme } from '../../config/theme';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import api from '../../config/api';

const Contact = () => {
  const toast = useToast();
  const [loading, setLoading] = React.useState(false);

  const { values, errors, touched, handleChange, handleBlur, validate, resetForm } = useForm(
    { name: '', email: '', subject: '', message: '' },
    {
      name: (value) => validators.name(value, 'Name'),
      email: (value) => validators.email(value),
      subject: (value) => validators.required(value, 'Subject'),
      message: (value) => validators.required(value, 'Message'),
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      toast.error('Please fix the highlighted fields.');
      return;
    }

    setLoading(true);
    try {
      await api.post('/contact/messages', {
        name: values.name,
        email: values.email,
        subject: values.subject,
        message: values.message,
      });

      toast.success('Thanks! Your message has been sent.');
      resetForm();
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ marginBottom: theme.spacing.xl }}>
          <h1 style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', fontWeight: theme.typography.fontWeight.bold, margin: 0 }}>
            Contact Us
          </h1>
          <p style={{ marginTop: theme.spacing.md, color: theme.colors.text.secondary, lineHeight: 1.7, maxWidth: 720 }}>
            Have a question, feedback, or need help with an order? Send us a message and we’ll get
            back to you as soon as possible.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: theme.spacing.xl }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: theme.spacing.xl }}>
            <Card padding="xl">
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: theme.spacing.md }}>
                <FaMapMarkerAlt size={18} color={theme.colors.primary.main} style={{ marginTop: 4 }} />
                <div>
                  <h3 style={{ margin: 0, fontSize: theme.typography.fontSize.lg, fontWeight: theme.typography.fontWeight.bold }}>
                    Address
                  </h3>
                  <p style={{ margin: `${theme.spacing.sm} 0 0`, color: theme.colors.text.secondary, lineHeight: 1.6 }}>
                    Address: C/O KAWOSHE ACHUMI, DOPN
                    CHEKIYE, BLOCK 5<br />
                    AGASA 4TH MILE, DIMAPUR
                       797115
                  </p>
                </div>
              </div>
            </Card>

            {/* <Card padding="xl">
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: theme.spacing.md }}>
                <FaPhoneAlt size={18} color={theme.colors.primary.main} style={{ marginTop: 4 }} />
                <div>
                  <h3 style={{ margin: 0, fontSize: theme.typography.fontSize.lg, fontWeight: theme.typography.fontWeight.bold }}>
                    Phone
                  </h3>
                  <p style={{ margin: `${theme.spacing.sm} 0 0`, color: theme.colors.text.secondary, lineHeight: 1.6 }}>
                    +1 (555) 123-4567
                  </p>
                </div>
              </div>
            </Card> */}

            <Card padding="xl">
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: theme.spacing.md }}>
                <FaEnvelope size={18} color={theme.colors.primary.main} style={{ marginTop: 4 }} />
                <div>
                  <h3 style={{ margin: 0, fontSize: theme.typography.fontSize.lg, fontWeight: theme.typography.fontWeight.bold }}>
                    Email
                  </h3>
                  <p style={{ margin: `${theme.spacing.sm} 0 0`, color: theme.colors.text.secondary, lineHeight: 1.6 }}>
                     contact@alarctrade.com
                  </p>
                </div>
              </div>
            </Card>
          </div>

          <Card padding="xl">
            <h2 style={{ margin: 0, fontSize: theme.typography.fontSize['2xl'], fontWeight: theme.typography.fontWeight.bold }}>
              Send a Message
            </h2>

            <form onSubmit={handleSubmit} style={{ marginTop: theme.spacing.xl }}>
              <FormInput
                label="Name"
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Your name"
                error={errors.name}
                touched={touched.name}
                required
              />

              <FormInput
                label="Email"
                name="email"
                type="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="your@email.com"
                error={errors.email}
                touched={touched.email}
                required
              />

              <FormInput
                label="Subject"
                name="subject"
                value={values.subject}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="How can we help?"
                error={errors.subject}
                touched={touched.subject}
                required
              />

              <FormTextarea
                label="Message"
                name="message"
                value={values.message}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Write your message..."
                error={errors.message}
                touched={touched.message}
                required
                rows={5}
              />

              <div style={{ display: 'flex', gap: theme.spacing.md, alignItems: 'center', flexWrap: 'wrap' }}>
                <Button type="submit" variant="primary" loading={loading} disabled={loading}>
                  {loading ? 'Preparing...' : 'Submit'}
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  disabled={loading}
                  onClick={() => resetForm()}
                >
                  Clear
                </Button>
              </div>

              <p style={{ marginTop: theme.spacing.md, color: theme.colors.text.secondary, fontSize: theme.typography.fontSize.sm, lineHeight: 1.6 }}>
                By submitting, you agree we may contact you regarding your message.
              </p>
            </form>
          </Card>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Contact;

